import type { HeadlineResponse } from '@on3/api';
import { On3IconLockPremium } from '@on3/icons';
import { toFriendlyDate } from '@on3/ui-lib/src/utils/date';
import { ResizedImage } from 'components/Image/ResizedImage';
import Link from 'next/link';

import styles from './PlayerNewsItem.module.scss';

export const PlayerNewsItem = ({
  featuredImage,
  title,
  fullUrl,
  author,
  postDate,
  isPremium,
}: HeadlineResponse) => {
  return (
    <article className={styles.block}>
      <div className={styles.content}>
        <Link href={fullUrl as string}>
          <h3 className={styles.title}>{title}</h3>
        </Link>
        <div className={styles.author}>
          <div className={styles.meta}>
            <Link href={`/user/${author?.niceName}/`}>{author?.name}</Link>
            <span>&#8226;</span>
            <span>{toFriendlyDate(postDate)}</span>
          </div>
          {isPremium && <On3IconLockPremium />}
        </div>
      </div>
      {featuredImage && (
        <Link className={styles.image} href={fullUrl as string}>
          <ResizedImage
            {...featuredImage}
            fit="cover"
            gravity="0.5x0.5"
            height={100}
            quality={90}
            width={160}
          />
        </Link>
      )}
    </article>
  );
};
